<template>
    <nav v-if="isShow && banner">
      <div id="modal">
        <div class="login-a"><img :src="banner.title" /></div>
        <div class="modal">
          <p><img :src="banner.body" /></p>
          <p @click="$emit('close')"><a >とじる</a></p>
        </div>
      </div>
    </nav>
</template>

<script>
export default {
    props: {
        isShow:Boolean,
        banner: Object
    },
    emits: ['close'],
  
}
</script>

<style>

</style>